// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"db30ba02","453":"ace21015","556":"ebd3a61d"}[chunkId] + ".chunk.js";
};